import { useQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import {
  useLocation,
  useParams,
  useNavigate } from
'react-router-dom';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Box,
  Grid,
  Typography } from
'@mui/material';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_AUTORIZACION_DETALLE } from '../../../data/graphQL/queries/PrecioControl/getAutorizacionDetalle';
import { AUTORIZAR_RECHAZO_MASIVO } from '../../../data/graphQL/mutations/PrecioAutorizacion/autorizacionPrecioMasivo';
import { InfoBox } from '../../EnvioCreation/components/InfoBox';
import { CustomSection } from '../../EnvioCreation/components/CustomSection';
import DocumentViewerBase64 from '../../../components/DocumentViewerBase64';
import { AttachedFile } from '../../../components/attachedFile/AttachedFile';

const ESTADO_PENDIENTE_ID = 1;
const ESTADO_APROBADO_ID = 2;
const ESTADO_RECHAZADO_ID = 3;

export const PrecioControlDetalle = ({ setChildrenAction }) => {
  const { state } = useLocation();
  const { idEstado } = state;
  const navigate = useNavigate();
  const { id } = useParams();

  const [modalType, setModalType] = useState(null);
  const [observacion, setObservacion] = useState('');
  const [errorObs, setErrorObs] = useState(false);

  const { data, loading } = useQuery(GET_AUTORIZACION_DETALLE, {
    variables: { idPrecioControl: parseInt(id) }
  });

  const detalle = data?.precioControlById;

  const [autorizarRechazoMasivo] = useMutation(AUTORIZAR_RECHAZO_MASIVO, {
    onCompleted: () => {
      navigate(-1);
    }
  });

  const abrirModal = (tipo) => {
    setModalType(tipo);
    setObservacion('');
    setErrorObs(false);
  };

  const handleConfirmarModal = () => {
    if (!observacion.trim()) {
      setErrorObs(true);
      return;
    }

    const payload = {
      idsAutorizacionControl: [parseInt(id)],
      observacion,
      idEstado: ESTADO_APROBADO_ID
    };

    if (modalType === 'aprobar')
    autorizarRechazoMasivo({ variables: payload });else
    if (modalType === 'rechazar') {
      payload.idEstado = ESTADO_RECHAZADO_ID;
      autorizarRechazoMasivo({ variables: payload });
    }

    setModalType(null);
  };

  useEffect(() => {
    if (detalle) {
      setChildrenAction(
        <div className='top-buttons' style={{ gap: 8 }}>
                    <CustomButton
            label='Rechazar'
            variant='contained'
            sx={{ background: '#636A73' }}
            disabled={idEstado !== ESTADO_PENDIENTE_ID || detalle?.evento === 'Cotizado' && !detalle?.archivoCotizacion}
            onClick={() => abrirModal('rechazar')} />
          
                    <CustomButton
            label='Aprobar'
            disabled={idEstado !== ESTADO_PENDIENTE_ID || detalle?.evento === 'Cotizado' && !detalle?.archivoCotizacion}
            variant='contained'
            onClick={() => abrirModal('aprobar')} />
          
                </div>
      );
    }
  }, [setChildrenAction, detalle, idEstado]);

  return (
    <>
            <CustomSection title="Detalle de autorización">
                <Grid container>
                    <Grid size={{ xs: 1.4 }}>
                        <Typography
              component="p"
              sx={{ fontSize: "12px", fontWeight: 700, fontFamily: "Helvetica" }}>
              
                            Adjunto
                        </Typography>
                        <AttachedFile
              file={{
                archivo: detalle?.archivoCotizacion?.archivo,
                contentType: detalle?.archivoCotizacion?.contentType,
                extension: detalle?.archivoCotizacion?.extension,
                titulo: detalle?.archivoCotizacion?.titulo
              }}
              title='Ver archivo' />
                    </Grid>
                </Grid>
                <Box
          sx={{
            display: "grid",
            gap: "30px",
            gridTemplateColumns: { lg: "repeat(6, 1fr)", md: "repeat(2, 1fr)" }
          }}>
          
                    <InfoBox label="Región" value={detalle?.region || '-'} />
                    <InfoBox label="Delegación" value={detalle?.delegacion || '-'} />
                    <InfoBox label="Evento" value={detalle?.evento || '-'} />
                    <InfoBox label="Fecha" value={detalle?.fecha || '-'} />

                    <InfoBox label="Solicitante" value={detalle?.solicitante || '-'} />
                    <InfoBox label="Contrato" value={detalle?.contrato || '-'} />
                    <InfoBox label="Minuta" value={detalle?.idMinuta || '-'} />
                    <InfoBox label="Financiador" value={detalle?.financiador || '-'} />

                    <InfoBox label="Período" value={detalle?.periodo || '-'} />
                    <InfoBox label="PN2" value={"$" + detalle?.precioControl?.toLocaleString() || '-'} />
                    <InfoBox label="Precio a cambiar" value={"$" + detalle?.precioACambiar?.toLocaleString() || '-'} />

                    <InfoBox label="Plan" value={detalle?.modulo || '-'} />
                    <InfoBox label="Código" value={detalle?.codigo || '-'} />

                    <InfoBox label="Observación" value={detalle?.observacion || '-'} />
                    <InfoBox label="Observación GG" value={detalle?.observacionGG || '-'} />
                </Box>
            </CustomSection>
            <Dialog open={!!modalType} onClose={() => setModalType(null)} fullWidth maxWidth="sm">
                <DialogTitle>
                    <strong>{modalType === 'aprobar' ? 'Aprobar autorización' : 'Rechazar autorización'}</strong>
                </DialogTitle>
                <DialogContent sx={{ pt: 1.5 }}>
                    <div style={{ marginBottom: 12, fontSize: 14 }}>
                        Por favor, debe ingresar una observación para el proceso masivo.
                    </div>
                    <TextField
            label="Observación"
            multiline
            rows={4}
            fullWidth
            value={observacion}
            onChange={(e) => {
              setObservacion(e.target.value);
              if (e.target.value.trim()) setErrorObs(false);
            }}
            error={errorObs} />
          
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={() => setModalType(null)} variant="outlined">
                        CERRAR
                    </Button>
                    <Button
            onClick={handleConfirmarModal}
            variant="contained"
            sx={
            modalType === 'rechazar' ?
            { background: '#636A73', color: 'white', '&:hover': { background: '#4f555d' } } :
            undefined
            }>
            
                        {modalType === 'aprobar' ? 'APROBAR' : 'RECHAZAR'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>);

};